import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logOut, setToken } from './slices/authSlice';
import { addToast } from './slices/uiSlice';
import store from './store';

const apiURL =
  process.env.REACT_APP_LOCAL_BACKEND === 'true'
    ? process.env.REACT_APP_LOCAL_BACKEND_URL
    : process.env.REACT_APP_PROD_URL;

const baseQuery = fetchBaseQuery({
  baseUrl: apiURL,
  mode: 'cors',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 403) {
    // We need to login again
    api.dispatch(logOut());
    // send refresh token to get new access token
    const refreshResult = await baseQuery('/refresh', api, extraOptions);
    if (refreshResult?.data) {
      // store the new token
      api.dispatch(setToken(refreshResult.data));
      // retry the original query with new access token
      result = await baseQuery(args, api, extraOptions);
    }
  } else if (result?.error) {
    store.dispatch(addToast({ title: 'Error', text: `Error: ${JSON.stringify(result?.error)}`, color: 'danger' }));
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: ['User', 'Activities', 'Equipment', 'Punches', 'Project', 'CostCategories', 'PunchOptions'],
});
